<template>
<div>
  <common-title :title="'用户信息'"></common-title>
  <user-info-components :paramEditMode="true"></user-info-components>
</div>
</template>

<script>
import commonTitle from "@/components/common/commonTitle";
import userInfoComponents from "@/components/user/userInfoComponents";
export default {
  components:{
    commonTitle,
    userInfoComponents
  },
}
</script>

<style scoped>

</style>